import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const AssistanceRedux = createActions({
  AssistanceByHourExcelRequest: [''],
  AssistanceByHourExcelSuccess: [''],
  AssistanceByHourExcelError: ['error'],
  AssistanceExcelRequest: ['start_date', 'end_date','path'],
  AssistanceExcelSuccess: [''],
  AssistanceExcelError: ['error'],
  AssistanceCenterExcelRequest: ['start_date', 'end_date','centerId','path'],
  AssistanceCenterExcelSuccess: [''],
  AssistanceCenterExcelError: ['error'],
},
{
  prefix: 'ASSISTANCE_',
  defaultActions: {
    get: true,
  },
},
)

const { Types, Creators } = AssistanceRedux
export const AssistanceTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

const AssistanceByHourExcelRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const AssistanceByHourExcelSuccess = state => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
}, d)
const AssistanceByHourExcelError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

const AssistanceExcelRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const AssistanceExcelSuccess = state => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
}, d)
const AssistanceExcelError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

const AssistanceCenterExcelRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const AssistanceCenterExcelSuccess = state => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
}, d)
const AssistanceCenterExcelError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

export const reducer = createReducer(INITIAL_STATE, {
  [Types.AssistanceByHourExcelRequest]: AssistanceByHourExcelRequest,
  [Types.AssistanceByHourExcelSuccess]: AssistanceByHourExcelSuccess,
  [Types.AssistanceByHourExcelError]: AssistanceByHourExcelError,
  [Types.AssistanceExcelRequest]: AssistanceExcelRequest,
  [Types.AssistanceExcelSuccess]: AssistanceExcelSuccess,
  [Types.AssistanceExcelError]: AssistanceExcelError,
  [Types.AssistanceCenterExcelRequest]: AssistanceCenterExcelRequest,
  [Types.AssistanceCenterExcelSuccess]: AssistanceCenterExcelSuccess,
  [Types.AssistanceCenterExcelError]: AssistanceCenterExcelError,
},
{
  defaultActions: {
    get: true,
  },
  Types,
},
)



// WEBPACK FOOTER //
// ./src/Data/Redux/AssistanceRedux.js